module.exports = __webpack_public_path__ + "media/images/onboard-org-1-53860d283f9d2aea1c4751a64e18cf17.svg";